export const DEFAULT_MAX_ICONS = 3
